import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#607d8b",
        secondary: "#2196f3",
        accent: "#009688",
        error: "#f44336",
        warning: "#ff5722",
        info: "#8bc34a",
        success: "#4caf50",
      },
    },
  },
});
